import { mediaMax } from "components/designV2/breakpoints";
import { Spacing } from "components/designV2/constants";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

export const BankTransferDetails = styled.div`
  display: grid;
  gap: ${Spacing.sm}px ${Spacing.md}px;
  grid-template-columns: minmax(0, 1fr) minmax(140px, auto);

  ${mediaMax.mobile} {
    gap: ${Spacing.xs}px;
    grid-template-columns: 1fr;
  }
`;

export const BankTransferLabel = styled.div`
  ${TypographyV2.b2}
  align-items: center;
  color: ${ColorV2.Blue4};
  display: flex;
  min-height: 40px;
`;

export const BankTransferValue = styled.div`
  ${TypographyV2.b1}
  align-items: center;
  color: ${ColorV2.Blue1};
  display: flex;
  justify-content: flex-end;
  justify-self: end;
  min-height: 40px;
  text-align: right;

  ${mediaMax.mobile} {
    justify-content: flex-start;
    justify-self: start;
    margin-bottom: ${Spacing.sm}px;
    text-align: left;
  }
`;

export const BankTransferFieldSlot = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  justify-self: end;
  min-height: 40px;
  min-width: 0;
  width: min(100%, 240px);

  ${mediaMax.mobile} {
    justify-content: flex-start;
    justify-self: start;
    margin-bottom: ${Spacing.sm}px;
  }
`;

export const BankTransferFooter = styled.div`
  align-items: center;
  display: flex;
  gap: ${Spacing.sm}px;
  justify-content: flex-end;

  ${mediaMax.mobile} {
    align-items: stretch;
    flex-direction: column;
  }
`;

export const BankTransferPrimaryButtonWrap = styled.div`
  display: inline-flex;
`;
